import { themeUi } from '../../themeUi/themeUi';

export const loginMigrations = {
  redisBackground: {
    color: themeUi.semantic.color.text.neutral100
  }
};
